import React, { Component } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import Tab from '@ertelecom/ui-react/components/tabs/tab';
import Tabs from '@ertelecom/ui-react/components/tabs/tabs';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { FlexBoxRow as Row } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';
import PromoGifts from '~/src/components/Promo/gifts';
import { getUrlParams } from '~/src/helpers/url';
import ShopItemCard from '~/src/components/Main/Info/ShopItemCard';
import * as ST from './styled';

const MESSAGE_DISCOUNTS_IS_LOADING = 'Подождите, скидки грузятся...';

class Promo extends Component {
    tabAdditional = 'Партнерские сервисы';
    tabDiscounts = this.props.isAuth ? 'Распродажа' : 'Скидки';
    state = {
        activeTab: this.tabDiscounts,
        bannerInfo: {},
    };

    componentDidMount() {
        const { isAuth, offerId } = this.props;

        if (isAuth) {
            if (!offerId) {
                this.setActiveTab();
            }
        }
        this.redirectFromCommunication();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isAuth && !this.props.isAuth) {
            this.tabDiscounts = 'Скидки';
            Router.push('/promo');
        }
    }

    switchTab = (label) => {
        this.setState({
            activeTab: label,
        });
    };

    setActiveTab = () => {
        const tab = getUrlParams(location).offersType;

        switch (tab) {
            case 'additional':
                this.setState({
                    activeTab: this.tabAdditional,
                });
                break;
            default:
                this.setState({
                    activeTab: this.tabDiscounts,
                });
        }
    };

    onSwitchTab = (activeTab) => {
        this.setState({
            activeTab,
        });
    };

    redirectFromCommunication = () => {
        const option = '#partner';
        if ((window) && (window.location.hash === option)) {
            this.setState({ activeTab: this.tabAdditional });
        }
    };

    render() {
        const { offerId, discounts, additionalServices, city, isAuth, accessToken } = this.props;
        const { activeTab, bannerInfo } = this.state;
        const subHeader = isAuth ? <ST.SubHeader>Распродажа</ST.SubHeader> : <ST.SubHeader>Скидки от Дом.ru</ST.SubHeader>;
        return (
            <GridContainer>
                <ST.Container>
                    <ST.Header>Акции</ST.Header>

                <Tabs activeTab={activeTab} onSwitchTab={this.onSwitchTab}>
                        <Tab label={this.tabDiscounts} data-test='promo-tab-discounts'>
                            {
                                <React.Fragment>
                                    {subHeader}
                                    {discounts?.length
                                        ? <PromoGifts
                                            offers={discounts}
                                            goToTab={() => {
                                                this.switchTab(this.tabDiscounts);
                                            }}
                                            bannerInfo={bannerInfo}
                                            offerPopupId={offerId}
                                            city={city}
                                            isAuth={isAuth}
                                            accessToken={accessToken}
                                        />
                                        : <ST.PromoLoading>{MESSAGE_DISCOUNTS_IS_LOADING}</ST.PromoLoading>
                                    }
                                </React.Fragment>
                            }
                        </Tab>

                        <Tab label={this.tabAdditional}>
                            {
                                <React.Fragment>
                                    <ST.SubHeader>
                                        Специальные предложения от партнеров
                                    </ST.SubHeader>
                                    <Row>
                                        {additionalServices?.length
                                            ?   additionalServices.map(item => (
                                                    <ShopItemCard
                                                        key={item.id}
                                                        item={item}
                                                        returnUrl={'/promo?offersType=additional'}
                                                    />
                                                ))
                                            :   null
                                        }
                                    </Row>
                                </React.Fragment>
                            }
                        </Tab>
                    </Tabs>
                </ST.Container>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    isAuth: state.auth.isAuth,
    accessToken: state.auth.accessToken,
});

export default connect(mapStateToProps)(Promo);
